module.exports = __webpack_public_path__ + "img/CtrlRoom_camera.a7d535b6.png";